import { useMutation } from "@tanstack/react-query";
import { useNotificationStore } from "@src/shared/components/Notification";
import { createRequestHH } from "@src/entities/requestHH/api/requests/createRequestHH";
import { AxiosError } from "axios";
import { useCenterNotificationStore } from "@src/shared/components/CenterNotification/model/store";

export const useCreateRequestHH = () => {
  const { showAlert } = useNotificationStore();
  const { openCenterAlert } = useCenterNotificationStore();
  const query = useMutation({
    mutationFn: createRequestHH,
    onSuccess: () => {
      openCenterAlert({
        message:
          "Ваш запрос отправлен в обработку. Проверить статус можно на странице “Результаты подбора”.",
      });
    },
    onError: (error: AxiosError) => {
      const response = error?.response?.data as {
        detail: { message: string; error: string };
      };
      const errorMessage = response?.detail.error || "";

      if (errorMessage.includes("not_enough_attempts")) {
        showAlert(response?.detail.message, "error");
        return;
      }
      if (errorMessage.includes("license_expired")) {
        showAlert(response?.detail.message, "error");
        return;
      }
      showAlert(error.message, "error");
    },
  });
  return query;
};
